import { PulseInstanceQueryOptions } from "@pulse/api/queryApi";
import { ModalProvider } from "@pulse/contexts/ModalProvider";
import StorageProvider from "@pulse/contexts/StorageProvider";
import Title from "@pulse/features/dashboard/DashboardHeader/Title";
import PulseAppProviders from "@pulse/PulseAppProviders";
import { queryClient } from "@pulse/queryClient";
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
import { PageLayout } from "frontend-components";
import { useEffect } from "react";

export const Route = createFileRoute("/_hub/$customerId/pulse/$pulseId")({
    component: RouteComponent,
    staticData: {
        titleFn: null,
    },
    loader: async ({ params }) => {
        await queryClient
            .ensureQueryData(PulseInstanceQueryOptions({ pulseInstanceId: +params.pulseId }))
            .catch((error) => {
                throw notFound(error);
            });
    },
});

function RouteComponent() {
    useEffect(() => {
        document.body.classList.add("pulse-theme");

        return () => {
            document.body.classList.remove("pulse-theme");
        };
    }, []);

    return (
        <PulseAppProviders>
            <StorageProvider>
                <ModalProvider>
                    <PageLayout theme="pulse-theme" pageTitle={<Title />}>
                        <Outlet />
                    </PageLayout>
                </ModalProvider>
            </StorageProvider>
        </PulseAppProviders>
    );
}
